// Trámite exprés (V249): el cliente solo entrega o retira documentación. Nace FINALIZADO, no pasa
// por un box y no cuenta en las estadísticas de Recepción.
//
// Los motivos espejan TurnoRecepcionService.MOTIVOS_EXPRES: no agregar uno sin sumarlo allá.

export const MOTIVO_EXPRES_OTRO = 'OTRO';

// `corta` es lo que entra en la píldora de las tarjetas, donde va el tipo de trámite en el resto
// de los turnos; `etiqueta` es la del formulario y el detalle.
export const MOTIVOS_EXPRES = [
    { valor: 'TRAE_DOCUMENTACION_PEDIDA', etiqueta: 'Trae documentación que se le pidió', corta: 'Trae documentación', icono: 'bi-box-arrow-in-down' },
    { valor: 'RETIRA_DOCUMENTACION', etiqueta: 'Retira documentación / copias', corta: 'Retira documentación', icono: 'bi-box-arrow-up' },
    { valor: 'FIRMA_DOCUMENTACION', etiqueta: 'Firma de documentación', corta: 'Firma', icono: 'bi-pen' },
    { valor: 'OLVIDO_EN_ATENCION', etiqueta: 'Se olvidó algo en la atención anterior', corta: 'Olvidó algo', icono: 'bi-arrow-counterclockwise' },
    { valor: MOTIVO_EXPRES_OTRO, etiqueta: 'Otro', corta: 'Otro', icono: 'bi-three-dots' },
];

/** Etiqueta corta para la píldora. "Otro" muestra el texto cargado (se recorta con "…"). */
export function etiquetaCortaMotivoExpres(valor, detalle) {
    if (!valor) return 'Trámite exprés';
    if (valor === MOTIVO_EXPRES_OTRO) return detalle || 'Otro';
    return MOTIVOS_EXPRES.find((m) => m.valor === valor)?.corta || valor;
}

export const MAX_DOCUMENTACION_EXPRES = 500;
export const MAX_MOTIVO_DETALLE_EXPRES = 200;
export const MAX_OBSERVACION_EXPRES = 500;

/** "Otro" muestra el texto que cargó recepción; el resto, la etiqueta de la lista. */
export function etiquetaMotivoExpres(valor, detalle) {
    if (!valor) return '';
    if (valor === MOTIVO_EXPRES_OTRO) return detalle ? `Otro: ${detalle}` : 'Otro';
    return MOTIVOS_EXPRES.find((m) => m.valor === valor)?.etiqueta || valor;
}

/** Los datos del exprés están completos para mandarlos al backend. */
export function datosExpresValidos({ documentacion, motivo, motivoDetalle }) {
    if (!String(documentacion || '').trim()) return false;
    if (!motivo) return false;
    if (motivo === MOTIVO_EXPRES_OTRO && !String(motivoDetalle || '').trim()) return false;
    return true;
}

export const DATOS_EXPRES_VACIOS = { documentacion: '', motivo: '', motivoDetalle: '', observaciones: '' };

// Azul clarito del trámite exprés: se distingue del verde de los finalizados y del naranja de los
// reingresos sin desentonar con la paleta de Recepción.
export const ESTILO_EXPRES = {
    bg: '#eff6ff',
    bgHover: '#dbeafe',
    border: '#bfdbfe',
    riel: '#60a5fa',
    text: '#1d4ed8',
};
